import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Tab,
  Tabs,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
// import UserAuditLogTable from "../../features/manageUsers/userAuditLogTable";
import VerificationModal from "../../Modals/verificationModal";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel({ children, value, index, ...other }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageUserDetail = () => {
  const navigate = useNavigate();

  const [valueTabs, setValueTabs] = useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const userProducts = [
    {
      id: 1,
      code: "PROD001",
      title: "Vintage Camera",
      category: "Electronics",
      subcategory: "Cameras",
      image: "/static/images/placeholder.png",
      date: "01-Sept-2025",
      status: "Approved",
    },
    {
      id: 2,
      code: "PROD003",
      title: "Programming Books Bundle",
      category: "Books",
      subcategory: "Educational",
      image: "/static/images/placeholder.png",
      date: "02-Sept-2025",
      status: "Reported",
    },
  ];

  const followers = [
    {
      id: 101,
      name: "John Doe",
      email: "john@example.com",
      since: "10-Aug-2025",
    },
    {
      id: 102,
      name: "Jane Smith",
      email: "jane@example.com",
      since: "22-Aug-2025",
    },
  ];

  const userActivityLogs = [
    {
      id: 1,
      activity: "Viewed Product",
      itemType: "Product",
      itemTitle: "Vintage Camera",
      itemCode: "PROD001",
      productId: 1,
      dateTime: "03-Sep-2025 10:30 AM",
    },
    {
      id: 2,
      activity: "Viewed Product",
      itemType: "Product",
      itemTitle: "Programming Books Bundle",
      itemCode: "PROD003",
      productId: 2,
      dateTime: "02-Sep-2025 05:15 PM",
    },
    {
      id: 3,
      activity: "Login",
      itemType: "Account",
      itemTitle: "Successful Login",
      itemCode: "-",
      productId: null,
      dateTime: "02-Sep-2025 09:02 AM",
    },
  ];

  return (
    <>
      <div className="main_title">
        <h1>User Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-users")}>
            Manage Users
          </button>{" "}
          - User Detail
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              className="custom_tabs_links"
            >
              <Tab label="Personal Info" {...a11yProps(0)} />
              <Tab label="Product Listing" {...a11yProps(1)} />
              <Tab label="Followers" {...a11yProps(2)} />
              <Tab label="Logs" {...a11yProps(3)} />
            </Tabs>
          </Box>
        </div>
      </div>

      {/* Personal Info */}
      <CustomTabPanel value={valueTabs} index={0}>
        <div className="cards view_page">
          <div className="table_header">
            <h2>Personal Info</h2>
            {/* <div className="right_s">
              <Button
                className="btn btn_primary sm"
                onClick={() => setOpenModal(true)}
              >
                Resend Verification
              </Button>
            </div> */}
          </div>
          <div className="gap_p">
            <div className="vew_img w_100">
              <h6>Image</h6>
              <figure>
                <img alt="user" src="/static/images/user_placeholder.png" />
              </figure>
            </div>
            <div className="w_33">
              <h6>First Name</h6>
              <p>Madelyn</p>
            </div>
            <div className="w_33">
              <h6>Last Name</h6>
              <p>Dias</p>
            </div>
            <div className="w_33">
              <h6>Email Address</h6>
              <p>madelyndias@gmail.com</p>
            </div>
            <div className="w_33">
              <h6>Phone</h6>
              <p>
                +91 9876543210{" "}
                {/* <img src="/static/images/tick_icon.svg" alt="verified" />{" "} */}
              </p>
            </div>
            <div className="w_33">
              <h6>Date Registered</h6>
              <p>01 March 2025</p>
            </div>
            <div className="w_33">
              <h6>Address</h6>
              <p>Address</p>
            </div>
            <div className="w_33">
              <h6>City</h6>
              <p>City</p>
            </div>
            <div className="w_33">
              <h6>Country</h6>
              <p>Country</p>
            </div>
            <div className="w_33">
              <h6>Account Status</h6>
              <p>Active</p>
            </div>
          </div>
        </div>
      </CustomTabPanel>

      {/* Product Listing */}
      <CustomTabPanel value={valueTabs} index={1}>
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <div className="section_title">
                <h2>Product Listing</h2>
              </div>
            </div>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Product ID</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {userProducts.map((p) => (
                  <TableRow hover key={p.id}>
                    <TableCell>{p.code}</TableCell>
                    <TableCell>
                      <Box>
                        <img
                          style={{ height: 40, width: 80, objectFit: "cover" }}
                          src={p.image}
                          alt={p.title}
                        />
                      </Box>
                    </TableCell>
                    <TableCell>{p.title}</TableCell>
                    <TableCell>
                      {p.category}
                      <br />
                      <small>{p.subcategory}</small>
                    </TableCell>
                    <TableCell>{p.date}</TableCell>
                    <TableCell>{p.status}</TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton
                          onClick={() => navigate(`/manage-products/detail`)}
                        >
                          <img src="/static/images/eye_icon.svg" alt="View" />
                        </IconButton>
                        <IconButton
                          onClick={() => navigate(`/manage-products/add`)}
                        >
                          <img src="/static/images/edit2_icon.svg" alt="Edit" />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </CustomTabPanel>

      {/* Followers */}
      <CustomTabPanel value={valueTabs} index={2}>
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <div className="section_title">
                <h2>Followers</h2>
              </div>
            </div>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Since</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {followers.map((f) => (
                  <TableRow hover key={f.id}>
                    <TableCell>{f.name}</TableCell>
                    <TableCell>{f.email}</TableCell>
                    <TableCell>{f.since}</TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton
                          onClick={() => navigate(`/manage-users/detail`)}
                        >
                          <img src="/static/images/eye_icon.svg" alt="View" />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </CustomTabPanel>

      {/* Logs */}
      <CustomTabPanel value={valueTabs} index={3}>
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <div className="section_title">
                <h2>User Activity Logs</h2>
              </div>
            </div>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Activity</TableCell>
                  <TableCell>Item</TableCell>
                  <TableCell>Date & Time</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {userActivityLogs.map((log) => (
                  <TableRow hover key={log.id}>
                    <TableCell>{log.activity}</TableCell>
                    <TableCell>
                      <div>
                        <strong>{log.itemTitle}</strong>
                        <br />
                        <small>
                          {log.itemType}
                          {log.itemCode && ` • ${log.itemCode}`}
                        </small>
                      </div>
                    </TableCell>
                    <TableCell>{log.dateTime}</TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        {log.itemType === "Product" && log.productId && (
                          <IconButton
                            onClick={() => navigate(`/manage-products/detail`)}
                          >
                            <img src="/static/images/eye_icon.svg" alt="View" />
                          </IconButton>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </CustomTabPanel>

      <VerificationModal
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default ManageUserDetail;
